import { useNavigate } from 'react-router-dom';

export default function Page401() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-6">
      <div className="text-center max-w-sm w-full">

        {/* Icon card */}
        <div className="relative mx-auto w-28 h-28 mb-6">
          <div className="absolute inset-0 bg-violet-500/10 rounded-3xl rotate-6" />
          <div className="absolute inset-0 bg-violet-500/10 rounded-3xl -rotate-3" />
          <div className="relative w-full h-full bg-gray-800 rounded-3xl flex items-center justify-center border border-gray-700/60">
            <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-violet-400">
              <circle cx="12" cy="8" r="4"/>
              <path d="M6 20v-1a6 6 0 0112 0v1"/>
              <line x1="17" y1="3" x2="21" y2="7"/>
              <line x1="21" y1="3" x2="17" y2="7"/>
            </svg>
          </div>
        </div>

        {/* Code */}
        <p className="text-[96px] font-black leading-none text-violet-500/15 select-none -mb-4">401</p>

        {/* Text */}
        <h1 className="text-2xl font-bold text-white mb-2">Oturum Sona Erdi</h1>
        <p className="text-gray-400 text-sm leading-relaxed mb-8">
          Oturumunuzun süresi dolmuş veya geçersiz hale gelmiş.
          <br />Devam etmek için tekrar giriş yapın.
        </p>

        {/* Actions */}
        <div className="flex flex-wrap gap-3 justify-center">
          <button
            onClick={() => navigate('/')}
            className="px-5 py-2.5 rounded-xl bg-gray-800 hover:bg-gray-700 text-gray-300 text-sm font-medium border border-gray-700 transition-colors">
            Ana Sayfa
          </button>
          <button
            onClick={() => navigate('/login')}
            className="px-5 py-2.5 rounded-xl bg-violet-600 hover:bg-violet-500 text-white text-sm font-medium transition-colors">
            Tekrar Giriş Yap
          </button>
        </div>
      </div>
    </div>
  );
}
